import React from 'react';

import PropTypes from 'prop-types';
import { Table, Checkbox } from 'semantic-ui-react';

import _get from 'lodash/get';
import _isNil from 'lodash/isNil';

import { getLocationDisplay } from 'components/modules/location/services/display';
import { LocationPropType } from 'components/modules/location/types/location';

import {
  ACTIVE_AT_LOCATION_NAME,
  DISPLAY_ON_LOCATION_PAGE_NAME,
} from '../../ServiceItemLocationSettings.constants';
import { ServiceItemLocationSettingPropType } from '../../ServiceItemLocationSettings.types';

const propTypes = {
  location: LocationPropType.isRequired,
  setting: ServiceItemLocationSettingPropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function TableRow({ location, setting, onChange: onChangeProp }) {
  const { id } = location;
  const locationName = getLocationDisplay(location);

  const activeAtLocation = !_isNil(_get(setting, 'locationId'));
  const displayOnLocationPage = _get(setting, 'displayOnLocationPage', false);

  function onChange(e, target) {
    const newTarget = { ...target, locationId: id };

    onChangeProp({ ...e, target: newTarget }, newTarget);
  }

  return (
    <Table.Row>
      <Table.Cell className="name">{locationName}</Table.Cell>
      <Table.Cell className="active-at-location">
        <Checkbox
          name={ACTIVE_AT_LOCATION_NAME}
          toggle
          checked={activeAtLocation}
          onClick={onChange}
        />
      </Table.Cell>
      <Table.Cell className="display-on-location-page">
        <Checkbox
          name={DISPLAY_ON_LOCATION_PAGE_NAME}
          toggle
          checked={displayOnLocationPage}
          onClick={onChange}
          disabled={!activeAtLocation}
        />
      </Table.Cell>
    </Table.Row>
  );
}

TableRow.propTypes = propTypes;
TableRow.defaultProps = defaultProps;
